import request from "@/router/axios"
export const all = () => {
    return request({
        url: `/api/jy/dept/list`,
        method: 'post',
        data: {
            filterParams: [{ name: "isValid", value: true }],
            orderBy: "id",
            isDesc: false
        }
    })
}

export const getHosDepts = () => {
    return request({
        url: `/api/jy/dept/getHosDepts`,
        method: 'get',
    })
}
export const editDept = (data) => {
    return request({
        url: `/api/jy/dept/edit`,
        method: 'post',
        data: data
    })
}
export const getUserHosDepts = () => {
    return request({
        url: `/api/jy/dept/getUserHosDepts`,
        method: 'get',
    })
}

export const saveDept = (data) => {
    return request({
        url: `/api/jy/dept/saveDept`,
        method: 'post',
        data: data
    })
}
